import { MerchantSolution, MerchantSolutionDefinition, MerchantSolutions } from './types';
import delivery from './DELIVERY/definition';
import webhooks from './API_WEBHOOKS/definition';

export const MerchantSolutionDefinitions: Record<MerchantSolution, MerchantSolutionDefinition> = {
	[MerchantSolutions.DELIVERY]: delivery,
	[MerchantSolutions.API_WEBHOOKS]: webhooks,
};
